import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Spin,
  Modal,
  Card,
  Typography,
  Empty,
  Table,
  PageHeader,
} from "antd";
import {
  ScanOutlined,
  HistoryOutlined,
  CloudUploadOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { FindFaceSearchForm } from "./FindFaceSearchForm";
import { FaceSearchResultsView } from "./FaceSearchResultsView";
import { FaceSearchAiLoader } from "./FaceSearchAiLoader";
import { faceSearchAction } from "../../_actions/face.search.service";
import { professionalAction } from "../../_actions";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { normalizeSearchResultForDisplay } from "./faceSearchResults.utils";
import { AI_THEME, AiStyles } from "./faceSearchTheme";
import moment from "moment";

const { Text } = Typography;

const FORM_PANEL_FLEX = "0 0 50%";
const FORM_PANEL_MIN_WIDTH = 480;

class FindFaceSearch extends React.Component {
  searchDataPanelRef = React.createRef();

  state = {
    mainView: "empty",
    searchResultsDisplay: null,
    faceSearchList: [],
    listLoading: false,
    taskId: null,
    faceSearchDetails: null,
    faceSearchDetailsLoading: false,
    selectedRecord: null,
    viewCrimeProfile: false,
    isSearching: false,
    searchStage: "",
    searchComplete: false,
    searchImageUrl: "",
    historyCurrent: 1,
    historyPageSize: 5,
    district_name: [],
  };

  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData,
      });
    });
  };
  componentDidMount() {
    this.getFindFaceSearchCityWise();
    if (this.props.user.role === "4") {
      this.props.dispatch(
        professionalAction.getDistrict(this?.props?.user?.cityId, 1),
      );
    }
    if (this.props.user.role === "2") {
      this.getDistrictsid();
    }
  }

  getFindFaceSearchCityWise = () => {
    this.setState({ listLoading: true });
    const { user } = this.props;
    faceSearchAction
      .getFindFaceSearchCityWise(user.id)
      .then((result) => {
        this.setState({ faceSearchList: result || [], listLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching face search list:", error);
        this.setState({ listLoading: false });
      });
  };

  onFormSubmit = (payload) => {
    console.log("payload", payload);
    this.getFindFaceSearchCityWise();
    this.setState(
      {
        mainView: "results",
        isSearching: false,
        searchComplete: false,
        searchResultsDisplay: normalizeSearchResultForDisplay(
          payload.result,
          payload.inputImageUrl,
        ),
        selectedRecord: null,
        faceSearchDetails: null,
      },
      this.scrollToSearchResults,
    );
  };

  getFaceSearchDetails = (taskId, record = null) => {
    this.setState(
      {
        faceSearchDetailsLoading: true,
        faceSearchDetails: null,
        selectedRecord: record,
        mainView: "details",
        taskId,
      },
      this.scrollToSearchResults,
    );
    faceSearchAction
      .getFaceSearchDetails(taskId)
      .then((result) => {
        this.setState(
          {
            faceSearchDetails: normalizeSearchResultForDisplay(result),
            faceSearchDetailsLoading: false,
          },
          this.scrollToSearchResults,
        );
      })
      .catch((error) => {
        console.error("Error fetching face search details:", error);
        this.setState({ faceSearchDetailsLoading: false });
      });
  };

  scrollToSearchResults = () => {
    window.requestAnimationFrame(() => {
      const panel = this.searchDataPanelRef.current;
      if (!panel) {
        return;
      }
      const offset = 72;
      const top =
        panel.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    });
  };

  onHistoryRowClick = (record) => {
    const taskId = record.taks_id || record.taskId;
    this.getFaceSearchDetails(taskId, record);
  };

  handleCrimeProfile = (criminalId) => {
    if (!criminalId) {
      return;
    }
    const { dispatch } = this.props;
    dispatch(professionalAction.getAllMaster());
    dispatch(professionalAction.getCriminalsViewsById(criminalId));
    this.setState({ viewCrimeProfile: true });
  };

  closeCrimeProfile = () => {
    this.setState({ viewCrimeProfile: false });
  };

  onFormReset = () => {};

  onLoadingChange = (
    isSearching,
    imageUrl = "",
    stage = "",
    complete = false,
  ) => {
    this.setState((prev) => ({
      isSearching,
      searchImageUrl: imageUrl || prev.searchImageUrl,
      searchStage: stage,
      searchComplete: complete,
      mainView: isSearching
        ? "searching"
        : prev.mainView === "searching"
          ? "empty"
          : prev.mainView,
    }));
  };

  renderSearchData() {
    const {
      mainView,
      searchResultsDisplay,
      faceSearchDetails,
      faceSearchDetailsLoading,
      selectedRecord,
      isSearching,
      searchImageUrl,
      searchStage,
      searchComplete,
    } = this.state;

    if (isSearching || mainView === "searching") {
      return (
        <div style={searchResultWrapStyle}>
          <FaceSearchAiLoader
            imageUrl={searchImageUrl}
            stage={searchStage}
            complete={searchComplete}
          />
        </div>
      );
    }

    if (mainView === "results" && searchResultsDisplay) {
      return (
        <div style={searchResultWrapStyle}>
          <FaceSearchResultsView
            status={searchResultsDisplay.status}
            statusMessage={searchResultsDisplay.statusMessage}
            inputImageUrl={searchResultsDisplay.inputImageUrl}
            matchResults={searchResultsDisplay.matchResults}
            onMatchClick={this.handleCrimeProfile}
          />
        </div>
      );
    }

    if (mainView === "details") {
      return (
        <div style={searchResultWrapStyle}>
          <Spin
            spinning={faceSearchDetailsLoading}
            tip="Loading face search details..."
          >
            {faceSearchDetails ? (
              <FaceSearchResultsView
                status={faceSearchDetails.status}
                statusMessage={faceSearchDetails.statusMessage}
                inputImageUrl={faceSearchDetails.inputImageUrl}
                matchResults={faceSearchDetails.matchResults}
                onMatchClick={this.handleCrimeProfile}
              />
            ) : (
              !faceSearchDetailsLoading && (
                <Card bordered={false} style={panelCardStyle}>
                  <Empty description="No details available" />
                </Card>
              )
            )}
            {selectedRecord && (
              <Card
                bordered={false}
                style={{ ...panelCardStyle, marginTop: 12 }}
                bodyStyle={{ padding: "12px 16px" }}
              >
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Task ID: {selectedRecord.taks_id || selectedRecord.taskId}
                  {" · "}
                  CR No.: {selectedRecord.cr_no || selectedRecord.crNo || "-"}
                  {" · "}
                  {selectedRecord.createdAt
                    ? moment(selectedRecord.createdAt).format(
                        "DD/MM/YYYY HH:mm",
                      )
                    : ""}
                </Text>
              </Card>
            )}
          </Spin>
        </div>
      );
    }

    return (
      <div style={emptyStateStyle}>
        <div style={emptyIconStyle}>
          <ScanOutlined />
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: AI_THEME.text,
            marginBottom: 8,
          }}
        >
          AI Face Search
        </div>
        <Text
          type="secondary"
          style={{ fontSize: 14, textAlign: "center", maxWidth: 360 }}
        >
          Upload a suspect photo on the left to run a new search, or click a row
          in the history table below.
        </Text>
      </div>
    );
  }

  onHistoryPaginationChange = (page, pageSize) => {
    this.setState({ historyCurrent: page, historyPageSize: pageSize });
  };

  onHistoryPageSizeChange = (current, size) => {
    this.setState({ historyCurrent: 1, historyPageSize: size });
  };

  renderHistoryTable() {
    const {
      faceSearchList,
      listLoading,
      selectedRecord,
      historyCurrent,
      historyPageSize,
    } = this.state;

    const columns = [
      {
        title: "SrNo",
        key: "srNo",
        width: 60,
        render: (text, record, index) => index + 1,
      },
      {
        title: "CR No.",
        dataIndex: "cr_no",
        key: "cr_no",
        render: (text, record) => record.cr_no || record.crNo,
      },
      {
        title: "Officer Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Mobile No.",
        dataIndex: "mobile_number",
        key: "mobile_number",
      },
      {
        title: "Task ID",
        dataIndex: "taks_id",
        key: "taks_id",
        render: (text, record) => record.taks_id || record.taskId,
      },
      {
        title: "Searched At",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text, record) =>
          record.createdAt ? moment(record.createdAt).format("DD/MM/YYYY") : "",
      },
      {
        title: "Action",
        key: "action",
        width: 90,
        render: (text, record) => (
          <Button
            type="primary"
            size="small"
            icon={<EyeOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              this.onHistoryRowClick(record);
            }}
          >
            View
          </Button>
        ),
      },
    ];

    return (
      <div style={historyPanelStyle}>
        <div style={historyPanelHeaderStyle}>
          <HistoryOutlined style={{ color: AI_THEME.primary, fontSize: 16 }} />
          <span style={{ fontWeight: 600, fontSize: 14, color: AI_THEME.text }}>
            History
          </span>
        </div>
        <div className="face-search-history-wrap" style={historyTableWrapStyle}>
          <Table
            bordered
            size="small"
            className="face-search-history-table"
            scroll={{ x: 900 }}
            loading={listLoading}
            columns={columns}
            dataSource={faceSearchList}
            rowKey={(record) => record.id || record.taks_id || record.taskId}
            rowClassName={(record) => {
              const taskId = record.taks_id || record.taskId;
              const selectedId = selectedRecord
                ? selectedRecord.taks_id || selectedRecord.taskId
                : null;
              return taskId === selectedId
                ? "govt-table-row face-search-row-selected"
                : "govt-table-row";
            }}
            pagination={{
              current: historyCurrent,
              pageSize: historyPageSize,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50"],
              size: "small",
              onChange: this.onHistoryPaginationChange,
              onShowSizeChange: this.onHistoryPageSizeChange,
            }}
            onRow={(record) => ({
              onClick: () => this.onHistoryRowClick(record),
              style: { cursor: "pointer" },
            })}
          />
        </div>
      </div>
    );
  }

  render() {
    const { user, professionals } = this.props;
    console.log("professionals face", professionals);
    return (
      <div className="face-search-page" style={pageShellStyle}>
        <style>{`
          .face-search-row-selected td {
            background: ${AI_THEME.primaryBg} !important;
          }

          .face-search-page {
            box-sizing: border-box;
            width: 100%;
          }

          .face-search-layout {
            width: 100%;
          }

          .face-search-top-row {
            display: flex;
            flex-shrink: 0;
            align-items: stretch;
            min-height: min(560px, calc(100vh - 300px));
            border-bottom: 1px solid ${AI_THEME.cardBorder};
          }

          .face-search-form-panel {
            flex: ${FORM_PANEL_FLEX};
            min-width: ${FORM_PANEL_MIN_WIDTH}px;
            max-width: 52%;
            display: flex;
            flex-direction: column;
            background: ${AI_THEME.card};
            border-right: 1px solid ${AI_THEME.cardBorder};
            overflow: hidden;
            min-height: 480px;
          }

          .face-search-form-content {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 16px 18px 20px;
            min-height: 0;
          }

          .face-search-form-content .face-search-form-sidebar .ant-form-item {
            margin-bottom: 14px;
          }

          .face-search-form-content .face-search-form-sidebar .ant-form-item-label > label {
            font-weight: 500;
            color: ${AI_THEME.text};
          }

          .face-search-form-content .face-search-form-sidebar > div > div > div {
            box-shadow: none;
            margin-bottom: 12px !important;
          }

          .face-search-form-content .face-search-form-sidebar .ant-alert {
            font-size: 12px;
          }

          .face-search-form-actions {
            display: flex;
            gap: 10px;
            margin-top: 4px;
          }

          .face-search-form-actions .ant-btn {
            flex: 1;
            min-width: 0;
            height: 40px;
          }

          .face-search-data-panel {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-width: 0;
            background: #fafbfc;
            overflow: hidden;
          }

          .face-search-data-content {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 12px 14px 16px;
            min-height: 0;
          }

          .face-search-history-table {
            width: 100%;
          }

          .face-search-history-table .ant-table {
            overflow-x: auto;
          }

          @media (min-width: 1200px) {
            .face-search-page {
              max-width: 1520px;
              margin: 0 auto;
              padding: 16px 24px 28px;
            }

            .face-search-top-row {
              min-height: min(620px, calc(100vh - 280px));
            }

            .face-search-form-content {
              padding: 18px 22px 24px;
            }

            .face-search-data-content {
              padding: 14px 18px 18px;
            }

            .face-search-panel-header {
              padding: 16px 24px;
            }
          }

          @media (min-width: 1600px) {
            .face-search-page {
              max-width: 1680px;
              padding: 20px 32px 36px;
            }

            .face-search-top-row {
              min-height: min(680px, calc(100vh - 260px));
            }

            .face-search-form-panel {
              max-width: 54%;
            }

            .face-search-form-content {
              padding: 20px 26px 28px;
            }

            .face-search-data-content {
              padding: 16px 20px 20px;
            }
          }

          @media (min-width: 1920px) {
            .face-search-page {
              max-width: 1800px;
            }

            .face-search-form-panel {
              max-width: 56%;
            }
          }

          @media (max-width: 991px) {
            .face-search-page {
              padding: 8px 12px 20px;
            }

            .face-search-top-row {
              flex-direction: column;
              min-height: auto;
            }

            .face-search-form-panel {
              flex: none;
              width: 100%;
              max-width: none;
              min-width: 0;
              min-height: auto;
              border-right: none;
              border-bottom: 1px solid ${AI_THEME.cardBorder};
            }

            .face-search-data-panel {
              min-height: 420px;
            }

            .face-search-form-content {
              max-height: none;
              padding: 16px 16px 20px;
            }

            .face-search-data-content {
              min-height: 360px;
              padding: 16px;
            }
          }

          @media (max-width: 575px) {
            .face-search-page {
              padding: 4px 8px 16px;
            }

            .face-search-panel-header {
              padding: 12px 14px;
            }

            .face-search-form-content,
            .face-search-data-content {
              padding: 14px 12px 18px;
            }
          }
        `}</style>

        <div className="face-search-layout" style={layoutStyle}>
          <PageHeader title="Face Search" style={{borderBottom:"2px solid #d9d9d9"}} />
          <AiStyles />
          <div className="face-search-top-row" style={topRowStyle}>
            <div className="face-search-form-panel" style={formPanelStyle}>
              <div className="face-search-panel-header" style={panelHeaderStyle}>
                <CloudUploadOutlined
                  style={{ color: AI_THEME.primary, fontSize: 16 }}
                />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: 15,
                    color: AI_THEME.text,
                  }}
                >
                  Upload Face
                </span>
              </div>
              <div className="face-search-form-content" style={formPanelContentStyle}>
                <FindFaceSearchForm
                  user={user}
                  onSubmit={this.onFormSubmit}
                  onReset={this.onFormReset}
                  onLoadingChange={this.onLoadingChange}
                  externalLoader
                  sidebar
                  district={
                    user.role === "2"
                      ? this.state.district_name
                      : professionals?.basicDistricts
                  }
                />
              </div>
            </div>

            <div
              className="face-search-data-panel"
              style={searchDataPanelStyle}
              ref={this.searchDataPanelRef}
            >
              <div className="face-search-panel-header" style={panelHeaderStyle}>
                <ScanOutlined
                  style={{ color: AI_THEME.primary, fontSize: 16 }}
                />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: 15,
                    color: AI_THEME.text,
                  }}
                >
                  AI Search Data
                </span>
              </div>
              <div className="face-search-data-content" style={searchDataContentStyle}>
                {this.renderSearchData()}
              </div>
            </div>
          </div>

          {this.renderHistoryTable()}
        </div>

        <Modal
          title="आरोपी प्रोफाइल"
          visible={this.state.viewCrimeProfile}
          onOk={this.closeCrimeProfile}
          onCancel={this.closeCrimeProfile}
          width="95%"
        >
          <ViewFormModel dataStates={professionals} />
        </Modal>
      </div>
    );
  }
}

const pageShellStyle = {
  background: AI_THEME.bg,
  minHeight: "calc(100vh - 120px)",
  padding: "12px 16px 24px",
};

const layoutStyle = {
  display: "flex",
  flexDirection: "column",
  minHeight: "calc(100vh - 140px)",
  borderRadius: AI_THEME.radius,
  border: `1px solid ${AI_THEME.cardBorder}`,
  boxShadow: AI_THEME.shadow,
  background: AI_THEME.card,
  width: "100%",
};

const topRowStyle = {};

const formPanelStyle = {};

const searchDataPanelStyle = {};

const panelHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "14px 20px",
  borderBottom: `1px solid ${AI_THEME.cardBorder}`,
  background: AI_THEME.card,
  flexShrink: 0,
};

const formPanelContentStyle = {};

const searchDataContentStyle = {};

const historyPanelStyle = {
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  background: AI_THEME.card,
  paddingBottom: 8,
};

const historyPanelHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "10px 16px",
  borderBottom: `1px solid ${AI_THEME.cardBorder}`,
  flexShrink: 0,
};

const historyTableWrapStyle = {
  padding: "8px 16px 16px",
  width: "100%",
  boxSizing: "border-box",
};

const searchResultWrapStyle = {
  width: "100%",
};

const panelCardStyle = {
  borderRadius: AI_THEME.radius,
  border: `1px solid ${AI_THEME.cardBorder}`,
  boxShadow: "none",
};

const emptyStateStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 380,
  height: "100%",
  padding: 32,
};

const emptyIconStyle = {
  width: 64,
  height: 64,
  borderRadius: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: AI_THEME.primaryBg,
  color: AI_THEME.primary,
  fontSize: 28,
  marginBottom: 16,
};

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return { user, professionals: state.professionals };
}

const connectedFindFaceSearch = connect(mapStateToProps)(FindFaceSearch);
export { connectedFindFaceSearch as FindFaceSearch };
